// extracted by mini-css-extract-plugin
export var center = "_4n-2";
export var clickableRow = "_4n-5";
export var expandedRow = "_4n-7";
export var hoverable = "_4n-4";
export var left = "_4n-1";
export var right = "_4n-3";
export var row = "_4n-0";
export var selectedRow = "_4n-6";
export var summaryRow = "_4n-8";